import { render } from "./ComposeView.vue?vue&type=template&id=25fa4232&scoped=true"
import script from "./ComposeView.vue?vue&type=script&lang=js"
export * from "./ComposeView.vue?vue&type=script&lang=js"

import "./ComposeView.vue?vue&type=style&index=0&id=25fa4232&scoped=true&lang=css"

import exportComponent from "C:\\OpenServer\\domains\\jm.loc\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25fa4232"]])

export default __exports__